
<div>
    <b-row>
        <b-col cols="8">
            <div class="head">
                <slot name="title(head)"></slot>
            </div>
            <div class="main">
                <slot name="title"></slot>
            </div>
            <div class="foot">
                <slot name="title(foot)"></slot>
            </div>
        </b-col>
        <b-col cols="2"></b-col>
        <b-col cols="2"></b-col>
    </b-row>
</div>
